import React from 'react'

const MwCardWrapper = ({children}) => {
    return (
        <div className='  w-[99.5%] m-auto bg-slate-50 rounded-lg'>{children}</div>
    )
}

export default MwCardWrapper